// extracted by css-extract-rspack-plugin
export default {"avatarWrapper":"AgentAvatar-module__avatarWrapper__oqf6r"};